import React, { useState, useEffect, useRef } from "react";
import AlertModal from "commonComponents/Popup/alertModal";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import {
    actionZoneBufferWidth,
    featureKey,
    NORMAL_POLYGON_Z_INDEX,
    mapSymbols,
    newPolyFillColor,
    actionZoneTypes,
    sizzleReelAZText,
    SELECTED_POLYGON_Z_INDEX,
    maximumMapZoomLevel,
    azEditingCursorCssClass,
    azCreateCursorCssClass,
    isUserBasic,
    isUserReadOnly,
    isFtPlusSite,
    canManageAzLimits,
    actionZoneLimits
} from "constant";
import { deepClone } from "../functions/deepClone";
import { createBufGeofenceVertices } from "../functions/geofence/createBufGeofenceVertices";
import { getCourseExtents } from "../functions/getCourseExtents";
import { getActionZoneColor } from "../functions/getActionZoneColor";
import { distanceCalc } from '../../Pins/utils/visageHelpers';
import { useDispatch, useSelector } from "react-redux";
import { useHookstate } from "@hookstate/core";
import { useTranslation } from "react-i18next";
import {
    MAP_GLOBAL_STATES,
    SITEID_GLOBAL_STATE,
    FLEET_GLOBAL_STATES,
    CPO_GLOBAL_STATES,
    SITELOCATION_GLOBAL_STATE,
    SiteSetupAction
} from "globalStore/globalStore";
import { useNavigate } from "react-router-dom";

export const ActionZones = ({
    mapData,
    mapsData,
    setZoomPosition,
    clickToDrivefeature,
    setTilted,
    setActiveCarList,
    setDiscardModalOnLeave,
    alertModalTitle,
    setAlertModalTitle,
    alertModalContent,
    setAlertModalContent,
    alertModalIsOpen,
    setAlertModalIsOpen,
    alertModalValidation,
    setAlertModalValidation,
    alertModalHandleOnSubmit,
    setAlertModalHandleOnSubmit,
    alertModalHandleOnClose
}) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();

    const {
        getCarPathActionZone,
        siteSettingsData,
        getUserRole
    } = useSelector((state) => state.commonReducers) || [];

    const { nextMainTabIndex, nextMainTabName } = useHookstate(CPO_GLOBAL_STATES);

    const { weatherAlertGlobalState } = useHookstate(FLEET_GLOBAL_STATES);

    const { siteLocationGlobalData } = useHookstate(SITELOCATION_GLOBAL_STATE);

    const { fleetType } = useHookstate(SiteSetupAction);

    const {
        mapSideNavTabState,
        cartPathActionZone,
        geofenceActionZone,
        messageActionZone,
        controlsActionZone,
        addActionZonePolygon,
        openActionZoneWindow,
        editActionZonePolygonData,
        editActionZonePolygonVertices,
        isEnabledActionZone,
        deactiveAllAction,
        toggleDeactiveAllAction,
        carNumberHover,
        clickWindowState,
        loadingOnProcess,
        courseExtents,
        actionZoneModified,
        editAzCssCursorToUse,
        editAzCssCursorLastUsed,
        isMouseOverPolygon,
        isDrawingNewPolygon,
        isMouseOverEdgeOrVertex,
        actionZoneId,
        currentAzClickedOnEditId,
        actionZoneButtonClicked,
        actionZoneAction,
        cancelActionZoneEdit,
        actionZoneRequest,
        saveActionZone,
        deleteActionZone,
        actionZoneVertexCount,
        hideSubNav,
        subNavDataState,
        cpoData,
        shouldInitCpoData,
        polygonSelectedForCpo,
        shouldCallCpoSelected,
        setCPOColor,
        shouldSetCpoColor,
        optionsCPOShowCourses,
        toggleAddActionZonePolygon,
        lastSelectedActionZoneImageId,
        refreshActionZones,
        currentClickedTab,
        azLimitPopupOpen,
        azLimitPopupMessage
    } = useHookstate(MAP_GLOBAL_STATES);

    const isAzLimitSite = isFtPlusSite(fleetType.get()) && canManageAzLimits(getUserRole && getUserRole?.Role);

    const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

    const siteIdValue = siteId.get();

    const [actionZonesPath, setActionZonesPath] = useState([]);
    const [actionZonesPolygons, setActionZonesPolygons] = useState([]); // array of google.maps.Polygon objects (polygons have extra property object actionZoneInfo)
    const [vertexToDeleteIndex, setVertexToDeleteIndex] = useState(-1);
    const [vertexToDeletePath, setVertexToDeletePath] = useState(null);
    const [drawingManager, setDrawingManager] = useState(null);
    const [isDeleteGeofenceAz, setIsDeleteGeofenceAz] = useState(false);
    const currentlyEditedPolygonRef = useRef(null);

    useEffect(() => {
        if (siteLocationGlobalData.get()) {
            setActiveCarList(true);
            drawingManager?.setDrawingMode(mapsData.drawing.OverlayType.FALSE);
            drawingManager?.setMap(null);
        }
    }, [siteLocationGlobalData.get()]);

    //When changing tabs, make sure to reload action zones
    useEffect(() => {
        if (mapSideNavTabState.get() === "Action Zones" || mapSideNavTabState.get() === "CPO") {
            dispatch(COMMON_SERVICES.getActionZoneServices(siteIdValue));
        }
    }, [mapSideNavTabState.get()]);

    useEffect(() => {
        if (getCarPathActionZone && (mapSideNavTabState.get() === "Action Zones" || mapSideNavTabState.get() === "CPO")) {
            let localGetCarPathActionZone = getCarPathActionZone;

            //If geofence was deleted then remove it from the array
            if (isDeleteGeofenceAz) {
                localGetCarPathActionZone = getCarPathActionZone.filter(x => x.IsGeofence == false)
            }

            setActionZonesPath(localGetCarPathActionZone);
        }
    }, [getCarPathActionZone]);

    useEffect(() => {
        if (actionZonesPath?.length > 0 && mapsData && (mapSideNavTabState.get() === "Action Zones" || mapSideNavTabState.get() === "CPO")) {
            //initialize
            if (siteSettingsData) {
                getCourseExtents(siteSettingsData, mapsData, courseExtents);

                // set the multiple courses flag
                if (siteSettingsData?.Courses?.length > 1) {
                    optionsCPOShowCourses.set(true);
                }
            }

            initActionZones();
            processActionZones();
        }

        localStorage.setItem("actionZoneButton", mapSideNavTabState.get() === "Action Zones");
    }, [actionZonesPath, mapsData]);

    useEffect(() => {
        if (mapsData && mapData) {
            var canEdit = (!isUserBasic(getUserRole && getUserRole?.Role) && !isUserReadOnly(getUserRole && getUserRole?.Role));

            setDrawingManager(new mapsData.drawing.DrawingManager({
                map: mapData,
                drawingControl: false, // true shows icons to add new polygon
                drawingControlOptions: {
                    position: mapsData.ControlPosition.TOP_CENTER,
                    drawingModes: [mapsData.drawing.OverlayType.POLYGON], // array of supported drawing modes
                },
                polygonOptions: {
                    strokeColor: getActionZoneColor(actionZoneTypes.NoSpeedRestriction),
                    strokeOpacity: 0.9,
                    strokeWeight: 2,
                    fillColor: newPolyFillColor, // so user can see new ones that haven't been saved yet
                    fillOpacity: 0.45,
                    clickable: true, // set this to true if wiring click event on the polygon
                    editable: canEdit,
                },
            }));
        }
    }, [mapsData, mapData]);

    useEffect(() => {
        if (mapsData && mapData && drawingManager) {
            mapsData.event.addListener(drawingManager, "overlaycomplete", function (event) {
                setActionZonesPolygons(prevPolygons => {
                    let localActionZonesPolygons = prevPolygons.slice();

                    if (addActionZonePolygon.get() && getPolygonVertices(event.overlay).length > 2) {
                        event.overlay.actionZoneInfo = getNewActionZoneInfo(); // event.overlay is the new polygon
                        localActionZonesPolygons.push(event.overlay);
                        actionZoneSelected(event.overlay, true);
                        event.overlay.actionZoneBuffer = addPolyline(event.overlay.actionZoneInfo);

                        actionZoneModified.set(true);
                        editActionZonePolygonData.set(event.overlay);
                    } else {
                        event.overlay.setMap(null);
                        event.overlay = null;
                    }

                    processActionZones(localActionZonesPolygons);

                    drawingManager.setDrawingMode(null);
                    isDrawingNewPolygon.set(false);

                    return localActionZonesPolygons; // Return the updated polygons array
                });
            });
        }
    }, [drawingManager]);

    useEffect(() => {
        if (actionZonesPolygons.length > 0) {
            actionZonesPolygons.forEach(polygon => {
                setPolygonListeners(polygon);
            });
        }
    }, [actionZonesPolygons]);

    //When zooming in or out of the map we change the action zone buffer polygon stroke width and change the cursor if needed
    useEffect(() => {
        if (mapData && actionZonesPolygons?.length) {
            var strokeWidth = actionZoneBufferWidth[mapData.getZoom() - 1];

            //Changes the cursor
            selectEditAzPolygonCursor(true);

            // update the AZ buffer width
            for (var p = 0; p < actionZonesPolygons.length; p++) {
                if (actionZonesPolygons[p].actionZoneBuffer) {
                    actionZonesPolygons[p].actionZoneBuffer.setOptions({
                        strokeWeight: strokeWidth
                    });
                }
            }
        }

        setZoomPosition(mapData?.getZoom());
    }, [mapData?.getZoom()]);

    //This handles when user clicks on Action Zone Control buttons (messages, control, car path only and geofence)
    useEffect(() => {
        var buttonFunc;

        //I want this to be called only when Control button is clicked and not on the first render as well
        if (Object.keys(actionZoneButtonClicked).length > 0) {
            switch (actionZoneButtonClicked.get()) {
                case "messages":
                    buttonFunc = closeActionZoneEditsOnMessage;
                    break;
                case "control":
                    buttonFunc = closeActionZoneEditsOnControl;
                    break;
                case "carpathonly":
                    buttonFunc = closeActionZoneEditsOnCarPathOnly;
                    break;
                case "geofence":
                    buttonFunc = closeActionZoneEditsOnGeofence;
                    break;
            }

            if (checkActionZoneModified()) {
                setDiscardModalOnLeave(buttonFunc);
            }
            else {
                buttonFunc();
            }
        }
    }, [actionZoneButtonClicked.get()]);

    useEffect(() => {
        if (refreshActionZones.get()) {
            if (checkActionZoneModified()) {
                setDiscardModalOnLeave(onTabChangeAzDiscardChanges);
            }

            refreshActionZones.set(false);
        }
    }, [refreshActionZones.get()]);

    //Every time we press action zones buttons (message, control, car path only and geofence) or click on cpo tab, re process action zones
    useEffect(() => {
        if (actionZonesPath?.length > 0 && mapsData) {
            if (mapSideNavTabState.get() === "Action Zones" || mapSideNavTabState.get() === "CPO") {
                processActionZones();
            } else {
                closeActionZoneEdits();
                cleanUpActionZone(); // remove existing action zones from map
                updateActionZoneBounds();
            }
        }
    }, [messageActionZone.get(), controlsActionZone.get(), cartPathActionZone.get(), geofenceActionZone.get()]);

    //Handles adding new action zone
    useEffect(() => {
        if (toggleAddActionZonePolygon.get() != null) {
            if (checkActionZoneModified()) {
                setDiscardModalOnLeave(handleAddActionZoneButton);
            }
            else {
                handleAddActionZoneButton();
            }
        }
    }, [toggleAddActionZonePolygon.get()]);

    //Handles when user clicks on deactive action zones
    useEffect(() => {
        if (toggleDeactiveAllAction.get() != null) {
            processActionZones();
        }
    }, [toggleDeactiveAllAction.get()]);

    useEffect(() => {
        if (Object.keys(editActionZonePolygonData).length > 0) {
            var colorFill = 'LightGray';

            if (isEnabledActionZone.get()) {
                colorFill = getActionZoneColor(editActionZonePolygonData.get().actionZoneInfo.Type, false);
            }

            if (!siteSettingsData.ActionZones) {
                colorFill = 'transparent';
            }

            var polygon = getSettablePolygon(editActionZonePolygonData.get().actionZoneInfo.Id);

            if (polygon) {
                polygon.setOptions({
                    fillColor: colorFill
                });
            }
        }
    }, [isEnabledActionZone.get()]);

    useEffect(() => {
        if (Object.keys(editActionZonePolygonData).length > 0) {
            var color = getActionZoneColor(actionZoneAction.get(), false);
            var colorFill = color;

            if (!isEnabledActionZone.get()) {
                colorFill = 'LightGray';
            }

            if (editActionZonePolygonData.get().actionZoneInfo.IsNew) {
                colorFill = newPolyFillColor; // so user can see new ones that haven't been saved yet
            }

            if (!siteSettingsData.ActionZones) {
                color = 'white';
                colorFill = 'transparent';
            }

            var polygon = getSettablePolygon(editActionZonePolygonData.get().actionZoneInfo.Id);

            if (polygon) {
                polygon.setOptions({
                    strokeColor: color,
                    fillColor: colorFill
                });
            }
        }
    }, [actionZoneAction.get()]);

    useEffect(() => {
        if (!openActionZoneWindow.get()) {
            let zones = actionZonesPolygons.map((item) => {
                item?.setOptions({ editable: false });
                return item;
            });
            setActionZonesPolygons(zones);
        }
    }, [openActionZoneWindow.get()]);

    useEffect(() => {
        if (Object.keys(editActionZonePolygonData).length > 0) {
            if (checkActionZoneModified()) {
                setDiscardModalOnLeave(handleCancelEditActionZone);
            } else {
                stopActionZonePanel();
            }

            addActionZonePolygon.set(false);
        }
    }, [cancelActionZoneEdit.get()]);

    //Handles Save Action Zone button
    useEffect(() => {
        if (Object.keys(actionZoneRequest).length > 0) {
            let localActionZoneRequest = { ...actionZoneRequest.get() };

            let poly = editActionZonePolygonData?.get();
            let actionZoneInfo = poly?.actionZoneInfo;
            let IsNew = actionZoneInfo?.IsNew;

            localActionZoneRequest.SiteId = siteIdValue;

            if (IsNew) {
                //The version assigned below is the version of the definition of data the makes up a serialized AZ (we are currently on 1).
                localActionZoneRequest.version = 1; // For now new Action Zones must always have a Version of 1 for AZ Serialization to work correctly.
            }

            if (localActionZoneRequest) {
                delete localActionZoneRequest.IsNew; // remove property that is not really part of the Action Zone

                var currentActionZonePolygonVertices = getPolygonVertices(poly);

                if (currentActionZonePolygonVertices?.length >= 2) {
                    // clear the scratch AZ vertices, and don't save the AZ if the length is 0
                    localActionZoneRequest.AzVertexes = [];

                    // Get the current vertices for this AZ
                    for (var v = 0; v < currentActionZonePolygonVertices.length; v++) {
                        localActionZoneRequest.AzVertexes.push({
                            Id: 0, // for some reason the Id was always 0 in the original returned data
                            Latitude: currentActionZonePolygonVertices[v].lat(),
                            Longitude: currentActionZonePolygonVertices[v].lng(),
                        });
                    }
                    // need to re-add first point (data from system duplicates starting and ending points)
                    var startIndex = 0;
                    if (localActionZoneRequest.IsGeofence)
                        startIndex = 2; // for Geofence, 1st two points are UL/LR of site extents, actual polygon starts on 3rd point

                    localActionZoneRequest.AzVertexes.push({
                        Id: 0, // for some reason the Id was always 0 in the original returned data
                        Latitude: currentActionZonePolygonVertices[startIndex].lat(),
                        Longitude: currentActionZonePolygonVertices[startIndex].lng(),
                    });
                }

                // if there are other AZs for this course and hole, match the enable setting
                let currentEditAzData = { ...editActionZonePolygonData.get() };
                for (var i = 0; i < actionZonesPath.length; i++) {
                    if (actionZonesPath[i].Hole > 0) {
                        if (actionZonesPath[i].Course === localActionZoneRequest.Course && actionZonesPath[i].Hole === localActionZoneRequest.Hole) {
                            localActionZoneRequest.IsEnabled = actionZonesPath[i].IsEnabled;
                            currentEditAzData.IsEnabled = actionZonesPath[i].IsEnabled;
                            editActionZonePolygonData.set(currentEditAzData);

                            break; // one match is enough
                        }
                    }
                }

                if (IsNew) {
                    localActionZoneRequest.IsEnabled = localActionZoneRequest.IsCartPathOnly ? true : localActionZoneRequest.IsEnabled;

                    dispatch(COMMON_SERVICES.addActionZoneServices(localActionZoneRequest, siteIdValue))
                        .then((result) => {
                            loadingOnProcess.set(false);

                            if (result) {
                                dispatch(COMMON_SERVICES.getActionZoneServices(siteIdValue));

                                addActionZonePolygon.set(false);
                                actionZoneModified.set(false);
                                editActionZonePolygonData.set(null);
                                //check if this save pushed us over zone limit, getCarPathActionZone hasnt updated in Redux yet so add 1 manually
                                if (isAzLimitSite) {
                                    const newCount = (getCarPathActionZone?.length ?? 0) + 1;
                                    if (newCount > actionZoneLimits.MAX_ACTION_ZONES) {
                                        azLimitPopupMessage.set(`Reduce number of action zones from ${newCount} to ${actionZoneLimits.MAX_ACTION_ZONES} or below`);
                                        azLimitPopupOpen.set(true);
                                    } else if (newCount === actionZoneLimits.MAX_ACTION_ZONES) {
                                        azLimitPopupMessage.set(`Number of action zones has been reached`);
                                        azLimitPopupOpen.set(true);
                                    }
                                }
                            } else {
                                errorSavingAzModal();
                            }
                        });

                    openActionZoneWindow.set(false);
                } else {
                    let payload = {
                        existingActionZone: getCarPathActionZone.find((a) => a.Id === actionZoneId.get()),
                        modifiedActionZone: localActionZoneRequest,
                    };

                    let zoneId = actionZoneId.get();
                    dispatch(
                        COMMON_SERVICES.editActionZoneServices(zoneId, siteIdValue, payload)
                    ).then((result) => {
                        loadingOnProcess.set(false);
                        if (result) {
                            dispatch(COMMON_SERVICES.getActionZoneServices(siteIdValue));
                            addActionZonePolygon.set(false);
                            actionZoneModified.set(false);
                            editActionZonePolygonData.set(null);

                        } else {
                            errorSavingAzModal();
                        }
                    });

                    openActionZoneWindow.set(false);
                }
            } else {
                errorSavingAzModal();
            }

            actionZoneRequest.set(null);
        }
    }, [saveActionZone.get()]);

    useEffect(() => {
        if (deleteActionZone.get() != null) {
            if (vertexToDeletePath && vertexToDeleteIndex > -1) {
                const updatedVertexToDeletePath = [...vertexToDeletePath];
                updatedVertexToDeletePath.splice(vertexToDeleteIndex, 1);

                setVertexToDeletePath(updatedVertexToDeletePath);
            } else if (editActionZonePolygonData.get()?.actionZoneInfo?.IsGeofence && !deleteActionZone.get()) {
                setAlertModalHandleOnSubmit(() => onResetGeofenceSubmit);
                setAlertModalTitle(t("Confirm"));
                setAlertModalContent(`${t("Reset_the_Geofence_to_the_course_extents?")}?`);
                setAlertModalIsOpen(true);
                setAlertModalValidation(false);
            } else {
                if (editActionZonePolygonData.get()?.actionZoneInfo?.IsNew) {
                    // if this is a new Action Zone, it is not yet in the database...
                    stopActionZonePanel();
                } else if (actionZoneId.get() != 0) {
                    dispatch(COMMON_SERVICES.deleteActionZoneServices(actionZoneId.get(), siteIdValue))
                        .then((result) => {
                            if (result) {
                                deleteActionZonePoly(getActionZonePolygonArrayIndexById(actionZoneId.get()));

                                let index = getActionZoneArrayIndexById(actionZoneId.get());
                                if (index !== -1 && actionZonesPath?.length) {
                                    const localActionZonesPath = [...actionZonesPath];
                                    localActionZonesPath.splice(index, 1);

                                    setActionZonesPath(localActionZonesPath);
                                }

                                if (editActionZonePolygonData?.get()?.actionZoneInfo?.IsGeofence) {
                                    setIsDeleteGeofenceAz(true);
                                    setAlertModalTitle("Geofence deleted");
                                    setAlertModalContent(`Refresh page to recreate geofence`);
                                    setAlertModalIsOpen(true);
                                    setAlertModalValidation(true);
                                }

                                dispatch(COMMON_SERVICES.hashActionZonesServices(siteIdValue));
                                stopActionZonePanel();
                                openActionZoneWindow.set(false);
                            }
                        });
                }
            }

            deleteActionZone.set(null);
            loadingOnProcess.set(false);
            actionZoneModified.set(false);
            hideDeleteVertexElement();
        }
    }, [deleteActionZone.get()]);

    //This is sets cpo color for CarPath.jsx
    useEffect(() => {
        if (shouldSetCpoColor.get()) {
            // Set the correct color for the CPO action zone
            var colorFill = "LightGray";

            setCPOColor.get()?.forEach(element => {
                if (element?.IsEnabled) {
                    colorFill = getActionZoneColor(element?.Type, false);
                }

                var polygon = getSettablePolygon(element?.Id);

                polygon.setOptions({
                    fillColor: colorFill
                });
            });

            shouldSetCpoColor.set(false);
        }
    }, [shouldSetCpoColor.get()]);

    //this use effect will allow user to click AZ after selecting and closing carDetail window options
    useEffect(() => {
        setTimeout(() => {
            if (!clickWindowState.get()) {
                carNumberHover.set(false);
            }
        }, 500);
    }, [clickWindowState.get()]);

    useEffect(() => {
        if (siteIdValue !== null) {
            dispatch(COMMON_SERVICES.getCannedMessagesServices(siteIdValue));
        }
        return () => {
            actionZonesPolygons.forEach((item) => {
                item.setMap(null);
            });
            actionZonesPolygons.length = 0;
        };
    }, []);

    useEffect(() => {
        if (siteId.get() !== null) {
            dispatch(COMMON_SERVICES.getCannedMessagesServices(siteId.get()));
        }
        return () => {
            actionZonesPolygons.forEach((item) => {
                item.setMap(null);
            });
            actionZonesPolygons.length = 0;
        };
    }, []);

    useEffect(() => {
        if (!mapsData || !mapData || !drawingManager) return;

        //this has it fire when using drawing manager for the az polygons, unlike addListener on mapData
        const handleMapClick = () => {
            if (drawingManager.getDrawingMode() === mapsData.drawing.OverlayType.POLYGON) {
                const newCount = actionZoneVertexCount.get() + 1;
                actionZoneVertexCount.set(newCount);

                if (isAzLimitSite && newCount === actionZoneLimits.MAX_VERTICES) {
                    // NEW: at exactly 140
                    azLimitPopupMessage.set(`The max number of vertices is ${actionZoneLimits.MAX_VERTICES}`);
                    azLimitPopupOpen.set(true);
                } else if (isAzLimitSite && newCount === actionZoneLimits.MAX_VERTICES + 1) {
                    // existing: over 140
                    azLimitPopupMessage.set(`Reduce number of vertices from ${newCount} to ${actionZoneLimits.MAX_VERTICES} or below`);
                    azLimitPopupOpen.set(true);
                }
                return;
            }

            if (mapSideNavTabState.get() === "Action Zones" && isAzLimitSite) {
                const count = getCarPathActionZone?.length ?? 0;

                if (count > actionZoneLimits.MAX_ACTION_ZONES) {
                    azLimitPopupMessage.set(`Reduce number of action zones from ${count} to ${actionZoneLimits.MAX_ACTION_ZONES} or below`);
                    azLimitPopupOpen.set(true);
                }
            }
        };

        const mapDiv = mapData.getDiv();
        mapDiv.addEventListener("click", handleMapClick);

        return () => mapDiv.removeEventListener("click", handleMapClick);
    }, [mapsData, mapData, drawingManager, isAzLimitSite]);

    const initActionZones = () => {
        cleanUpActionZone();
        actionZonesPolygons.length = 0;

        if (actionZonesPath) {
            addActionZones();
        } else {
            setActionZonesPath(null);
        }

        if (siteSettingsData) {
            shouldInitCpoData.set(true);
        }
    }

    const errorSavingAzModal = () => {
        setAlertModalTitle(t("Message"));
        setAlertModalContent(t("Error_saving_Action_Zone"));
        setAlertModalIsOpen(true);
        setAlertModalValidation(true);
    }

    const onResetGeofenceSubmit = () => {
        var inPath = createCourseExtentsPolygonPath();
        var outPath = createOutGeofenceVertices(inPath);
        var paths = [outPath, inPath];

        var currentActionZone = getSettablePolygon(editActionZonePolygonData.get().actionZoneInfo.Id);

        currentActionZone.setOptions({
            paths: paths
        });

        currentActionZone.actionZoneBuffer.setOptions({
            path: inPath
        });

        setPolygonListeners(currentActionZone);

        editActionZonePolygonData.set(currentActionZone);
        setAlertModalIsOpen(false);
        actionZoneModified.set(true);
    }

    const cleanUpActionZone = () => {
        // Clear polygons from map
        if (mapData && mapsData && actionZonesPolygons?.length !== 0) {
            actionZonesPolygons.forEach((item) => {
                if (item?.actionZoneBuffer) {
                    item?.actionZoneBuffer?.setMap(null);
                }

                item?.setMap(null);
            });
        }
    }

    const handleAddActionZoneButton = () => {
        if (isAzLimitSite && (getCarPathActionZone?.length ?? 0) >= 200) {
            azLimitPopupMessage.set(`Number of action zones has been reached (${getCarPathActionZone?.length ?? 0}/${actionZoneLimits.MAX_ACTION_ZONES})`);
            azLimitPopupOpen.set(true);
            return;
        }

        actionZoneVertexCount.set(0);
        addActionZonePolygon.set(!addActionZonePolygon.get());
        editActionZonePolygonData.set({});
        isEnabledActionZone.set(true);
        setAlertModalIsOpen(false);

        setNewActionZonePoly();
        stopActionZonePanel();
        openActionZoneWindow.set(true);
    };

    const getNewActionZoneInfo = () => {
        return {
            IsNew: true, // not a property of the Action Zone dto so delete it before posting/putting
            Message: "new action zone",
            IsEnabled: true,
            IsEnforcedForMarshal: false,
            IsEnforcedForHandicapped: false,
            IsEnforcedForBeverage: false,
            IsEnforcedForMemberCars: false,
            IsEnforcedForMemberCarSpecial: false,
            IsEnforcedForGolf: true,
            EnforceTimeRestriction: false,
            TimeEnd0: new Date(2000, 0, 1, 0, 0, 0),
            TimeEnd1: new Date(2000, 0, 1, 0, 0, 0),
            TimeStart0: new Date(2000, 0, 1, 0, 0, 0),
            TimeStart1: new Date(2000, 0, 1, 0, 0, 0),
            Type: actionZoneTypes.NoSpeedRestriction,
            IsBeepInActionZone: false,
            IsAlertOnEnter: false,
            IsShowOnVDU: false,
            Label: "Action zone",
            Hole: 0,
            Course: 0,
            IsCartPathOnly: false,
            IsGeofence: false,
            ActivationDirection: -1,
            ImageFilename: "",
            ImageId: null,
        };
    }

    const addActionZones = () => {
        //Need to clone the object otherwise you can't modify the original one since is read only
        var clonedActionZonesPath = deepClone(actionZonesPath);

        for (var i = 0; i < clonedActionZonesPath.length; i++) {
            // add the AZ polygons
            if (clonedActionZonesPath[i].AzVertexes) {
                addPolygon(clonedActionZonesPath[i]);
            }
        }

        // clear the AZ modified flag
        actionZoneModified.set(false);
    }

    const addPolygon = (actionZone) => {
        var paths = [];
        var inPath = [];
        var outPath = [];

        inPath = createInVertices(actionZone);

        if (inPath.length > 0) {
            var color = getActionZoneColor(actionZone.typeId);

            // if necessary, create the vertices for the outer Geofence path
            if (actionZone.IsGeofence) {
                outPath = createOutGeofenceVertices(inPath);
            }

            if (inPath.length && outPath.length)
                paths = [outPath, inPath];
            else {
                paths = inPath;
            }

            var polygon = new mapsData.Polygon({
                paths: paths,
                strokeColor: color,
                strokeOpacity: 0.9,
                strokeWeight: 2,
                fillColor: color,
                fillOpacity: 0.45,
                clickable: true, // set this to true if wiring click event on the polygon
                editable: false,
                zIndex: NORMAL_POLYGON_Z_INDEX
            });

            // add an extra property to the polygon so we can retrieve the details when the polygon is clicked
            polygon.actionZoneInfo = getActionZoneInfo(actionZone);
            polygon.actionZoneBuffer = addPolyline(actionZone);
            setPolygonListeners(polygon);
            polygon?.setMap(null);
            actionZonesPolygons.push(polygon);
        }
    }

    const addPolyline = (actionZone) => {
        var inPath = [];
        var bufPath = [];

        inPath = createInVertices(actionZone);

        if (inPath.length > 0) {
            var color = getActionZoneColor(actionZone.typeId);
            var strokeWidth = actionZoneBufferWidth[mapData.getZoom() - 1];

            // create the vertices for the buffer
            bufPath = createBufGeofenceVertices(inPath);

            // Regular polyline options
            var polylineOptions = {
                path: bufPath,
                strokeColor: color,
                strokeOpacity: 0.3,
                strokeWeight: strokeWidth,
                clickable: false,
                editable: false
            };

            // optional modification of polyline options for action zones w/ form specified
            if (actionZone.Message && actionZone.Message.substring(0, 5) == "FORM:") {
                polylineOptions = {
                    ...polylineOptions,
                    icons: [{ icon: mapSymbols.DIAMOND, repeat: "20px" }]
                }
            }

            var polyline = new mapsData.Polyline(polylineOptions);

            polyline?.setMap(null);

            return polyline;
        }
        return null;
    }

    const setPolygonListeners = (polygon) => {
        if (!polygon) return;

        var paths = polygon.getPaths();
        var path = paths.getAt(paths.length - 1);

        // Detect mobile
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

        mapsData.event.addListener(polygon, "rightclick", function (event) {
            clickToDrivefeature(event);
        });

        mapsData.event.addListener(mapData,
            "bounds_changed",
            () => {
                const actionZonesTab = "Action Zones";
                const siteSetUpTab = "Site Setup";
                const historyTab = "History";
                if ((mapSideNavTabState.get() === actionZonesTab || mapSideNavTabState.get() === siteSetUpTab || mapSideNavTabState.get() === historyTab) && mapData.getTilt() === 45) {
                    mapData.setTilt(0);
                    setTilted(false);
                }
            });

        mapsData?.event.addListener(polygon, "rightclick", function (e) {
            // Check if click was on a vertex control point
            if (e.vertex === undefined) {
                mapsData?.event.trigger(mapData, "rightclick", e); // propogate in case we're using ClickToDrive on map
                return;
            }
            if (e.path !== null && e.vertex !== null) {
                hideDeleteVertexElement();

                var thePath = paths.getAt(e.path);
                if (thePath.getLength() > 3) {
                    thePath.removeAt(e.vertex);
                }
            }
        });

        // ---------- CLICK HANDLER ----------
        // Will be overridden for mobile with long-press handling
        const handlePolygonClick = function (point) {
            const isAlreadyEditingThisPolygon = openActionZoneWindow.get() && currentlyEditedPolygonRef.current === polygon;

            if (!carNumberHover.get() && !isAlreadyEditingThisPolygon) {
                selectAZPolygon(polygon);
            }
            if (point.vertex !== undefined) {
                var localVertexToDeletePath = paths.getAt(point.path);
                setVertexToDeletePath(localVertexToDeletePath);
                if (localVertexToDeletePath.getLength() > 3) {
                    setVertexToDeleteIndex(point.vertex);
                    createDeleteVertexElement().open(mapData, polygon.getPaths().getAt(point.path), point.vertex, polygon);
                }
            } else {
                hideDeleteVertexElement();
            }
        };

        mapsData?.event.addListener(polygon, "click", handlePolygonClick);

        mapsData?.event.addListener(polygon, "mouseup", function (e) {
            // Check if click was on a vertex control point
            if (e.vertex === undefined) {
                return;
            }
            if (e.path !== null && e.vertex !== null) {
                hideDeleteVertexElement();
                // Unfortunately the e.latLng position that is passed in here is for the position prior to when the vertex was
                // actually moved.  So we will need to process this in the "set_at" event handler for the path
            }
        });

        mapsData?.event.addListener(polygon, "mousemove", function (point) {
            isMouseOverPolygon.set(true);
            isMouseOverEdgeOrVertex.set(!isNaN(point.edge) || !isNaN(point.vertex));
            selectEditAzPolygonCursor(false);
            mouseOverAZPolygon(point.latLng);
        });

        mapsData?.event.addListener(polygon, "mouseout", function () {
            mouseOutAZPolygon(polygon);
            isMouseOverEdgeOrVertex.set(false);
            isMouseOverPolygon.set(false);
            selectEditAzPolygonCursor(false);
        });

        //  MOBILE LONG PRESS and PINCH FIX 
        if (isMobile) {
            let longPressTimer = null;
            let isPinching = false;
            let initialDistance = 0;

            const getDistance = (touches) => {
                const [t1, t2] = touches;
                const dx = t2.clientX - t1.clientX;
                const dy = t2.clientY - t1.clientY;
                return Math.sqrt(dx * dx + dy * dy);
            };

            // touchstart to detect pinch or long press
            mapsData.event.addListener(polygon, "mousedown", (e) => {
                const touches = e.domEvent?.touches;

                if (touches?.length === 2) {
                    isPinching = true;
                    initialDistance = getDistance(touches);
                    clearTimeout(longPressTimer);
                    return;
                }

                isPinching = false;

                longPressTimer = setTimeout(() => {
                    if (!isPinching) {
                        actionZoneSelected(polygon, false, true);
                    }
                }, 600);
            });

            // touchmove detect pinch
            mapsData.event.addListener(polygon, "mousemove", (e) => {
                const touches = e.domEvent?.touches;

                if (touches?.length === 2) {
                    const newDistance = getDistance(touches);

                    if (Math.abs(newDistance - initialDistance) > 5) {
                        isPinching = true;
                        clearTimeout(longPressTimer);
                    }
                }
            });

            // touchend cleanup
            mapsData.event.addListener(polygon, "mouseup", (e) => {
                clearTimeout(longPressTimer);
                const touches = e.domEvent?.touches;
                if (!touches || touches.length === 0) {
                    isPinching = false;
                }
            });

            mapsData.event.addListener(polygon, "mouseout", () => {
                clearTimeout(longPressTimer);
            });

            // overriding click (short tap)
            mapsData?.event.clearListeners(polygon, "click");
            mapsData?.event.addListener(polygon, "click", function (point) {
                if (isPinching) return;
                handlePolygonClick(point);
            });
        }

        // ---------- PATH (vertex) LISTENERS ----------
        if (path) {
            attachPathVertexListeners(polygon);
        }
        if (mapSideNavTabState.get() === "CPO") {
            hideSubNav.set(true);
            subNavDataState.set("Map");
        }
    }

    const setPolygonActionZoneBufferPath = (polygon) => {
        // update the buffer path for this polygon
        if (polygon && polygon.actionZoneBuffer) {
            var bufPath = [];
            var paths = polygon.getPaths();
            var path = paths.getAt(paths.length - 1);
            if (path) {
                for (var v = 0; v < path.length; v++) {
                    if (mapsData) {
                        bufPath.push(
                            new mapsData.LatLng(
                                path.getAt(v).lat(),
                                path.getAt(v).lng()
                            )
                        );
                    }
                }
                // Re-add the first vertex to close the polyline
                if (mapsData) {
                    bufPath.push(new mapsData.LatLng(path.getAt(0).lat(), path.getAt(0).lng()));
                }
                polygon.actionZoneBuffer.setPath(bufPath);
            }
        }
    }

    const mouseOutAZPolygon = (polygon) => {
        if (polygon) {
            // reset the polygon appearance and lower the zIndex
            polygon.setOptions({
                fillOpacity: 0.45,
                zIndex: NORMAL_POLYGON_Z_INDEX
            });
        }
    }

    const mouseOverAZPolygon = (latLng) => {
        var polygons = [];
        var poly = null;

        // get all of the AZ polygons for this point
        polygons = getAZPolygons(latLng);

        // find the smallest of those polygons
        if (polygons.length === 1) {
            poly = polygons[0];
        } else if (polygons.length > 0) {
            var smallestPoly = polygons[0];
            var smallestArea = mapsData.geometry.spherical.computeArea(
                smallestPoly.getPath()
            );
            for (var x = 1; x < polygons.length; x++) {
                var area = mapsData.geometry.spherical.computeArea(
                    polygons[x].getPath()
                );
                if (area < smallestArea) {
                    smallestArea = area;
                    smallestPoly = polygons[x];
                }
            }
            poly = smallestPoly;
        }

        // highlight the polygon, and increase the zIndex
        if (poly) {
            poly.setOptions({
                fillOpacity: 0.65,
                zIndex: SELECTED_POLYGON_Z_INDEX,
            });
        }
    }

    const getAZPolygons = (latLng) => {
        var polys = [];
        // find all polygons that contain the point latLng
        for (var x = 0; x < actionZonesPolygons.length; x++) {
            if (
                mapsData.geometry.poly.containsLocation(
                    latLng,
                    actionZonesPolygons[x]
                )
            ) {
                // set all of the polygons to a normal appearance and zIndex
                actionZonesPolygons[x].setOptions({
                    fillOpacity: 0.45,
                    zIndex: NORMAL_POLYGON_Z_INDEX,
                });
                polys.push(actionZonesPolygons[x]);
            }
        }
        return polys;
    }

    const selectAZPolygon = (polygon) => {
        if (polygon?.actionZoneInfo) {
            // if a new AZ polygon has been found
            if (mapSideNavTabState.get() === "Action Zones") {
                if (checkActionZoneModified()) {
                    //currentAzClickedOnEditId is for when user clicks from one az to another so we actionZoneId becomes the previous az and currentAzClickedOnEditId becomes the newest one clicked
                    currentAzClickedOnEditId.set(polygon?.actionZoneInfo?.Id);
                    setDiscardModalOnLeave(onAzDiscardChanges);
                } else {
                    actionZoneSelected(polygon);
                }
            } else if (mapSideNavTabState.get() == "CPO") {
                actionZoneSelected(polygon);
            }
        }
    }

    const onAzDiscardChanges = () => {
        stopActionZonePanel();

        //currentAzClickedOnEditId is for when user clicks from one az to another so we actionZoneId becomes the previous az and currentAzClickedOnEditId becomes the newest one clicked
        let polygon = getSettablePolygon(currentAzClickedOnEditId.get());
        actionZoneSelected(polygon);
        setAlertModalIsOpen(false);
    }

    const onTabChangeAzDiscardChanges = () => {
        cancelActionZoneEditHelper();

        setAlertModalIsOpen(false);

        if (nextMainTabIndex.get()) {
            navigate(`/${nextMainTabName.get().toLowerCase()}`);
            nextMainTabIndex.set("");
        } else {
            subNavDataState.set("");
        }

        localStorage.setItem("activeMapSideNavTab", currentClickedTab.get());
        localStorage.setItem("mapSideNavTabState", currentClickedTab.get());
        mapSideNavTabState.set(currentClickedTab.get());
    }

    const checkActionZoneModified = () => {
        if (cpoData.get()?.length || actionZoneModified.get() || checkVertices()) {
            return true;
        }

        return false;
    }

    const checkVertices = () => {
        if (Object.keys(editActionZonePolygonData).length > 0 && Object.keys(editActionZonePolygonVertices).length > 0) {
            var verts = getPolygonVertices(editActionZonePolygonData.get());

            if (verts.length) {
                if (verts.length !== editActionZonePolygonVertices.get().length)
                    return true;
                else {
                    for (var i = 0; i < verts.length; i++) {
                        if (verts[i].lat() !== editActionZonePolygonVertices.get()[i].lat() || verts[i].lng() !== editActionZonePolygonVertices.get()[i].lng()) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }

    const getPolygonVertices = (polygon) => {
        // need to return a new array; don't just return polygon.getPath() or polygon.getPath().getArray()
        var arr = [];

        if (polygon) {
            var paths = polygon?.getPaths?.();
            var path = paths?.getAt(paths.length - 1);
            if (path) {
                for (var x = 0; x < path.length; x++) {
                    if (mapsData) {
                        arr.push(new mapsData.LatLng(path.getAt(x).lat(), path.getAt(x).lng()));
                    }
                }
                if (polygon.actionZoneInfo && polygon.actionZoneInfo.IsGeofence && courseExtents.get()) {
                    // for backwards compatibilty, add the course extents
                    // at the beginning of the Geofence vertices array
                    for (x = 0; x < courseExtents.get().length; x++) {
                        arr.splice(x, 0, courseExtents.get()[x]);
                    }
                }
            }
        }
        return arr;
    }

    const updateVertexCount = (polygon) => {
        if (!polygon) return;
        var verts = getPolygonVertices(polygon);
        if (polygon.actionZoneInfo && polygon.actionZoneInfo.IsGeofence) {
            actionZoneVertexCount.set(verts.length - 2); // exclude the prepended course-extent points
        } else {
            actionZoneVertexCount.set(verts.length);
        }
    };

    const attachPathVertexListeners = (polygon) => {
        if (!polygon) return;

        var paths = polygon.getPaths();
        var path = paths.getAt(paths.length - 1);

        if (!path) return;

        mapsData?.event.addListener(path, "set_at", function (vertex) {
            actionZoneModified.set(true);
            // Check to see if e.latLng is within 1.5 meters of vertex immediately before or after the moved vertex.
            // If so treat this as the user intention is to remove the current vertex by having it absorbed by the moved to vertex
            // Note that vertex numbering starts with 0, i.e. it is zero based so we have to account for that below
            setPolygonActionZoneBufferPath(polygon);
            if (path.getLength() > 3) {
                // adjust tolerance for zoom level so user can still merge adjacent vertices when zoomed
                // out furter and it still is easy to do and feels right.
                var adjustedTolerance = Math.pow(2, maximumMapZoomLevel - mapData.getZoom()) * 0.00125;
                var beforeVertex = vertex > 0 ? vertex - 1 : path.getLength() - 1;
                var afterVertex = vertex === path.getLength() - 1 ? 0 : vertex + 1;
                if (distanceCalc.distanceBetweenPoints(path.getAt(vertex), path.getAt(beforeVertex)) < adjustedTolerance ||
                    distanceCalc.distanceBetweenPoints(path.getAt(vertex), path.getAt(afterVertex)) < adjustedTolerance) {
                    // Note the timeout is required or we get an exception in Google Maps
                    setTimeout(function () {
                        path.removeAt(vertex);
                        updateVertexCount(polygon);
                    }, 100);
                } else {
                    setPolygonActionZoneBufferPath(polygon);
                }
            } else {
                setPolygonActionZoneBufferPath(polygon);
            }
        });

        mapsData?.event.addListener(path, "insert_at", function () {
            actionZoneModified.set(true);
            setPolygonActionZoneBufferPath(polygon);
            updateVertexCount(polygon);
        });

        mapsData?.event.addListener(path, "remove_at", function () {
            actionZoneModified.set(true);
            setPolygonActionZoneBufferPath(polygon);
            updateVertexCount(polygon);
        });
    };

    const actionZoneSelected = (polygon, isSelectingNewlyCreatedActionZone, isLongPress = false) => {
        var i = 0;
        const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        if (mapSideNavTabState.get() === "Action Zones") {
            cancelActionZoneEditHelper();

            // Get the currentActionZone data
            //Logic for getCurrentActionZoneInfo is dealt on useEffect on index page located on sideNav/subSectionNav/Map/ActionZone/ActionZonesSubNav/index 
            actionZoneId.set(polygon?.actionZoneInfo?.Id);
            getCurrentActionZonePolygon(polygon);

            // Set the map
            if (drawingManager) {
                drawingManager?.setMap(mapData);
            }

            // Only open the menu if this was a long press
            if (!isMobile || isLongPress) {
                openActionZoneWindow.set(true);
            }

            if (isSelectingNewlyCreatedActionZone) {
                // A newly created Action Zone that is selected does not have any listeners associated with it so we need to add them here
                mapsData.event.addListener(
                    polygon,
                    "mousemove",
                    function (point) {
                        isMouseOverPolygon.set(true);
                        isMouseOverEdgeOrVertex.set(!isNaN(point.edge) || !isNaN(point.vertex));
                        selectEditAzPolygonCursor(false);
                    }
                );

                mapsData.event.addListener(
                    polygon,
                    "mouseout",
                    function () {
                        isMouseOverPolygon.set(false);
                        selectEditAzPolygonCursor(false);
                    }
                );
            }
        } else if (mapSideNavTabState.get() === "CPO") {
            //This is handle on useEffect on CarPath.jsx
            shouldCallCpoSelected.set((prev) => !prev);
            polygonSelectedForCpo.set(polygon);
        } else {
            setAlertModalTitle(t("Message"));
            setAlertModalContent("Action Zone Editing error");
            setAlertModalIsOpen(true);
            setAlertModalValidation(true);

            if (polygon?.actionZoneInfo) {
                // an error has occured, remove this AZ polygon from the map
                deleteActionZonePoly(getActionZonePolygonArrayIndexById(polygon?.actionZoneInfo?.Id));
            }
        }
    }

    const selectEditAzPolygonCursor = (clearCurrentCursorStyle) => {
        let localEditAzCssCursorToUse = editAzCssCursorToUse.get();
        let localEditAzCssCursorLastUsed = editAzCssCursorLastUsed.get();

        // We only have special cursors for the three most zoomed in levels of Google Maps API (18,19, and 20)
        // And, we only show the special cursors if we are over a polygon or we are drawing a new polygon
        if ((isMouseOverPolygon.get() || isDrawingNewPolygon.get()) && mapData?.getZoom() > 17) {
            // Select Cursor to use based on whether we are over an edge or vertext control point or not
            if (isDrawingNewPolygon.get() || isMouseOverEdgeOrVertex.get()) {
                localEditAzCssCursorToUse = azCreateCursorCssClass[mapData?.getZoom() - 1] ? azCreateCursorCssClass[mapData?.getZoom() - 1] : azCreateCursorCssClass[azCreateCursorCssClass.length];
            } else {
                localEditAzCssCursorToUse = azEditingCursorCssClass[mapData?.getZoom() - 1] ? azEditingCursorCssClass[mapData?.getZoom() - 1] : azEditingCursorCssClass[azEditingCursorCssClass.length];
            }

            // If the new cursor to use is different than the prior cursor, then clear out the prior cursor
            if (localEditAzCssCursorLastUsed && (localEditAzCssCursorLastUsed !== localEditAzCssCursorToUse || clearCurrentCursorStyle)) {
                if (mapData?.getDiv()?.className?.includes(localEditAzCssCursorLastUsed)) {
                    mapData.getDiv().className = mapData.getDiv().className.replace(localEditAzCssCursorLastUsed, "");
                }
            }
            // Apply the new cursor style and save away as last used
            mapData.getDiv().className = localEditAzCssCursorToUse;
            localEditAzCssCursorLastUsed = localEditAzCssCursorToUse;
        } else {
            // We are not over the polygon anymore or we zoomed out to google maps level 17 or less,
            // so revert to default cursor
            if (mapData?.getDiv()?.className?.includes(localEditAzCssCursorToUse)) {
                mapData.getDiv().className = mapData.getDiv().className.replace(localEditAzCssCursorToUse, "");
            }

            localEditAzCssCursorLastUsed = null;
        }

        if (localEditAzCssCursorToUse !== editAzCssCursorToUse.get()) {
            editAzCssCursorToUse.set(localEditAzCssCursorToUse);
        }

        if (localEditAzCssCursorLastUsed !== editAzCssCursorLastUsed.get()) {
            editAzCssCursorLastUsed.set(localEditAzCssCursorLastUsed);
        }
    }

    const cancelActionZoneEditHelper = () => {
        if (Object.keys(editActionZonePolygonData).length > 0) {
            let localActionZoneId = actionZoneId?.get()
            var pIndex = getActionZonePolygonArrayIndexById(localActionZoneId);
            var zIndex = getActionZoneArrayIndexById(localActionZoneId);

            let polygon = getSettablePolygon(localActionZoneId);

            if (polygon) {
                disablePolygonEditMode(polygon);

                polygon?.setMap(null);

                if (polygon?.actionZoneInfo?.IsNew) {
                    deleteActionZonePoly(getActionZonePolygonArrayIndexForNew());
                }
            }

            if (checkVertices()) {
                if (pIndex !== -1 && zIndex !== -1) {
                    deleteActionZonePoly(pIndex);
                    addPolygon(actionZonesPath[zIndex]);

                    setActionZonesPolygons(actionZonesPolygons);
                }
            }

            processActionZones();
            editActionZonePolygonData.set(null);
            toggleAddActionZonePolygon.set(null);
            addActionZonePolygon.set(null);
        }

        actionZoneId.set(0);
        actionZoneModified.set(false);
        lastSelectedActionZoneImageId.set(null);
        currentlyEditedPolygonRef.current = null;
    }

    const getSettablePolygon = (id) => {
        return actionZonesPolygons.find(x => x.actionZoneInfo.Id == id);
    }

    const getCurrentActionZonePolygon = (polygon) => {
        if (polygon) {
            currentlyEditedPolygonRef.current = polygon;
            var canEdit = (!isUserBasic(getUserRole && getUserRole?.Role) && !isUserReadOnly(getUserRole && getUserRole?.Role));

            let localActionZonePolygonVertices = editActionZonePolygonVertices.get();

            localActionZonePolygonVertices = getPolygonVertices(polygon);

            if (editActionZonePolygonData?.get()?.IsGeofence) {
                actionZoneVertexCount.set(localActionZonePolygonVertices.length - 2); // don't count the UL/LR points that prepend the list
            }
            else {
                actionZoneVertexCount.set(localActionZonePolygonVertices.length);
            }

            if (polygon) {
                actionZoneModified.set(polygon.actionZoneInfo.IsNew);
                polygon.setOptions({ editable: canEdit });
            }

            editActionZonePolygonData.set(polygon);
            editActionZonePolygonVertices.set(localActionZonePolygonVertices);
        }
    }

    const getActionZonePolygonArrayIndexForNew = () => {
        // return -1 if not found (assumes there can only be one in the IsNew state at a time)
        var index = -1;
        if (actionZonesPolygons) {
            for (var az = 0; az < actionZonesPolygons.length; az++) {
                if (actionZonesPolygons[az].actionZoneInfo.IsNew) {
                    index = az;
                    break;
                }
            }
        }
        return index;
    }

    const getActionZonePolygonArrayIndexById = (id) => {
        // return -1 if not found
        var index = -1;
        if (actionZonesPolygons) {
            for (var az = 0; az < actionZonesPolygons.length; az++) {
                if (actionZonesPolygons[az]?.actionZoneInfo?.Id === id) {
                    index = az;
                    break;
                }
            }
        }
        return index;
    }

    const getActionZoneArrayIndexById = (id) => {
        // return -1 if not found
        var index = -1;
        if (actionZonesPath) {
            for (var az = 0; az < actionZonesPath.length; az++) {
                if (actionZonesPath[az].Id === id) {
                    index = az;
                    break;
                }
            }
        }
        return index;
    }

    const disablePolygonEditMode = (polygon) => {
        if (polygon) {
            polygon.setOptions({
                editable: false,
                strokeWeight: 2,
                fillOpacity: 0.45,
            });
        }

        if (drawingManager) {
            drawingManager?.setMap(null);
        }
    }

    const deleteActionZonePoly = (index) => {
        let localActionZonesPolygons = actionZonesPolygons;

        if (index !== -1 && localActionZonesPolygons?.length) {
            // remove this polygon from the map
            if (localActionZonesPolygons[index].actionZoneBuffer)
                localActionZonesPolygons[index].actionZoneBuffer.setMap(null);

            localActionZonesPolygons[index].setMap(null);
            localActionZonesPolygons.splice(index, 1);
            updateActionZoneBounds();

            setActionZonesPolygons(localActionZonesPolygons);
        }
    }

    const createInVertices = (actionZone) => {
        var inPath = [];
        var getCourseExtents = courseExtents.get();

        if (actionZone.IsGeofence) {
            // If the course extents are being used for the Geofence
            if (actionZone.AzVertexes.length === getCourseExtents.length) {
                // Add the missing AZ vertices
                actionZone.AzVertexes = createCourseExtentsVertices();
            }
            else {
                var ULLRprepended = true;
                // check to see if the first vertices are different from the course extents
                for (var v = 0; v < getCourseExtents.length; v++) {
                    if (!nearlyEqual(actionZone.AzVertexes[v].Latitude, getCourseExtents[v].lat()) || !nearlyEqual(actionZone.AzVertexes[v].Longitude, getCourseExtents[v].lng())) {
                        ULLRprepended = false;
                        break;
                    }
                }
                if (ULLRprepended) {
                    // remove the course extents, and use the remaining vertices for the polygon
                    actionZone.AzVertexes.splice(0, getCourseExtents.length);
                }
            }

            for (var v = 0; v < actionZone.AzVertexes.length - 1; v++) {
                // google closes the polygon without repeating the last point
                if (mapsData) {
                    inPath.push(new mapsData.LatLng(actionZone.AzVertexes[v].Latitude, actionZone.AzVertexes[v].Longitude));
                }
            }
        }
        else {
            if (actionZone.AzVertexes) {
                // set the AZ polygon path 
                for (v = 0; v < actionZone.AzVertexes.length - 1; v++) {
                    // google closes the polygon without repeating the last point
                    if (mapsData) {
                        inPath.push(new mapsData.LatLng(actionZone.AzVertexes[v].Latitude, actionZone.AzVertexes[v].Longitude));
                    }
                }
            }
            else if (addActionZonePolygon.get()) {
                // set the new AZ polygon path
                for (v = 0; v < editActionZonePolygonVertices.get().length; v++) {
                    if (mapsData) {
                        inPath.push(new mapsData.LatLng(editActionZonePolygonVertices.get()[v].lat(), editActionZonePolygonVertices.get()[v].lng()));
                    }
                }
            }
        }
        return inPath;
    }

    // JG 09 May 16: added this for use in comparison below which determines whether the UL/LR points are prepended
    // This was failing at times because the original code looked for precise match, and didn't account for slight variance
    // often seen with floating point numbers.
    const nearlyEqual = (v1, v2) => {
        return Math.abs(v1 - v2) < 0.000005;    // close enough to equal (JG 24/Oct/18: raised this a bit to accomodate slight errors when displaying Chinese sites with GCJ-02 projection)
    }

    const createCourseExtentsVertices = () => {
        var ceVerts = [];
        var cePath = createCourseExtentsPolygonPath();
        if (cePath.length) {
            for (var v = 0; v < cePath.length; v++) {
                ceVerts.push({
                    'Id': 0,
                    'Latitude': cePath[v].lat(),
                    'Longitude': cePath[v].lng()
                });
            }
            // close the polygon by repeating the first point in the array
            ceVerts.push({
                'Id': 0,
                'Latitude': cePath[0].lat(),
                'Longitude': cePath[0].lng()
            });
        }
        return ceVerts;
    }

    const createCourseExtentsPolygonPath = () => {
        var cePath = [];
        var getCourseExtents = courseExtents.get();

        if (getCourseExtents?.length) {
            // set the path based on the course extents
            cePath.push(getCourseExtents[0]);

            if (mapsData) {
                cePath.push(new mapsData.LatLng(getCourseExtents[0].lat(), getCourseExtents[1].lng()));
            }

            cePath.push(getCourseExtents[1]);

            if (mapsData) {
                cePath.push(new mapsData.LatLng(getCourseExtents[1].lat(), getCourseExtents[0].lng()));
            }
        }
        return cePath;
    }

    const createOutGeofenceVertices = (inPath) => {
        var outPath = [];
        if (inPath && inPath.length) {
            var out = 0.02; // this sets increase value for the outer polygon
            var bounds = new mapsData.LatLngBounds();

            // get the bounds of this polygon
            inPath.forEach(function (coord) {
                bounds.extend(coord);
            });

            // Calculate the outer vertices based on the polygon bounds + out value then push them into the outPath array in reverse order
            if (mapsData) {
                outPath.push(new mapsData.LatLng(bounds.getSouthWest().lat() - out, bounds.getSouthWest().lng() - out));
                outPath.push(new mapsData.LatLng(bounds.getSouthWest().lat() - out, bounds.getNorthEast().lng() + out));
                outPath.push(new mapsData.LatLng(bounds.getNorthEast().lat() + out, bounds.getNorthEast().lng() + out));
                outPath.push(new mapsData.LatLng(bounds.getNorthEast().lat() + out, bounds.getSouthWest().lng() - out));
            }
        }
        return outPath;
    }

    const getActionZoneInfo = (actionZone) => {
        return {
            'IsNew': false, // not a property of the Action Zone dto so delete it before posting/putting
            'Id': actionZone.Id,
            'Message': actionZone.Message,
            'IsEnabled': actionZone.IsEnabled,
            'IsEnforcedForMarshal': actionZone.IsEnforcedForMarshal,
            'IsEnforcedForHandicapped': actionZone.IsEnforcedForHandicapped,
            'IsEnforcedForBeverage': actionZone.IsEnforcedForBeverage,
            'IsEnforcedForMemberCars': actionZone.IsEnforcedForMemberCars,
            'IsEnforcedForMemberCarSpecial': actionZone.IsEnforcedForMemberCarSpecial,
            'EnforceTimeRestriction': actionZone.EnforceTimeRestriction,
            'TimeStart0': actionZone.TimeStart0,
            'TimeEnd0': actionZone.TimeEnd0,
            'TimeStart1': actionZone.TimeStart1,
            'TimeEnd1': actionZone.TimeEnd1,
            'IsEnforcedForGolf': actionZone.IsEnforcedForGolf,
            'Type': actionZone.Type,
            'IsBeepInActionZone': actionZone.IsBeepInActionZone,
            'IsAlertOnEnter': actionZone.IsAlertOnEnter,
            'IsShowOnVDU': actionZone.IsShowOnVDU,
            'Label': actionZone.Label,
            'Hole': actionZone.Hole,
            'Course': actionZone.Course,
            'IsCartPathOnly': actionZone.IsCartPathOnly,
            'IsGeofence': actionZone.IsGeofence,
            'ActivationDirection': actionZone.ActivationDirection,
            'ImageFilename': actionZone.ImageFilename,
            'ImageId': actionZone.ImageId
        };
    }

    //azPolygons parameters is OPTIONAL
    const processActionZones = (azPolygons) => {
        let localActionZonesPolygons = azPolygons ? azPolygons : actionZonesPolygons;

        // Show AZ polygons based on filter settings
        for (var i = 0; i < localActionZonesPolygons.length; i++) {
            // clear the current AZ from the map
            localActionZonesPolygons[i].setMap(null);
            localActionZonesPolygons[i].actionZoneBuffer.setMap(null);

            // get the correct AZ appearance settings
            var color = getActionZoneColor(localActionZonesPolygons[i].actionZoneInfo.Type, localActionZonesPolygons[i].actionZoneInfo.Message == sizzleReelAZText);
            var colorFill = color;
            var opacityFill = 0.45;
            var strokeWidth = actionZoneBufferWidth[mapData.getZoom() - 1];

            if (deactiveAllAction.get()) {
                color = 'white';
                colorFill = 'transparent';
            }
            else if (siteSettingsData?.Features?.indexOf(featureKey.resortEdition) >= 0 && weatherAlertGlobalState.get()) {
                color = 'white';                // on Resort sites AZs are disabled during weather alert
                colorFill = 'transparent';
            }
            else if (localActionZonesPolygons[i].actionZoneInfo.IsEnabled === false) {
                colorFill = 'LightGray';
            }
            else if (localActionZonesPolygons[i].actionZoneInfo.IsNew) {
                colorFill = newPolyFillColor;
            }

            localActionZonesPolygons[i].setOptions({
                strokeColor: color,
                fillColor: colorFill,
                fillOpacity: opacityFill
            });

            localActionZonesPolygons[i].actionZoneBuffer.setOptions({
                strokeColor: color,
                strokeWeight: strokeWidth
            });

            if (localActionZonesPolygons[i].actionZoneInfo.IsNew) {
                localActionZonesPolygons[i].setMap(mapData);
                localActionZonesPolygons[i].actionZoneBuffer.setMap(mapData);
            }

            //  if (mapSideNavTabState.get() === "Action Zones" && optionsShowSurveys()) {
            //      if (localActionZonesPolygons[i].actionZoneInfo.Message && localActionZonesPolygons[i].actionZoneInfo.Message.substring(0,5) == "FORM:") {
            //        localActionZonesPolygons[i].setMap(mapData);
            //        localActionZonesPolygons[i].actionZoneBuffer.setMap(mapData);
            //      }
            //  }

            if (mapSideNavTabState.get() === "Action Zones" && messageActionZone.get()) {
                if (localActionZonesPolygons[i].actionZoneInfo.Hole === 0 &&
                    localActionZonesPolygons[i].actionZoneInfo.Type === actionZoneTypes.NoSpeedRestriction &&
                    !localActionZonesPolygons[i].actionZoneInfo.IsGeofence) {
                    localActionZonesPolygons[i].setMap(mapData);
                    localActionZonesPolygons[i].actionZoneBuffer.setMap(mapData);
                }
            }

            if (mapSideNavTabState.get() === "Action Zones" && controlsActionZone.get()) {
                if (localActionZonesPolygons[i].actionZoneInfo.Hole === 0 &&
                    localActionZonesPolygons[i].actionZoneInfo.Type !== actionZoneTypes.NoSpeedRestriction &&
                    !localActionZonesPolygons[i].actionZoneInfo.IsGeofence) {
                    localActionZonesPolygons[i].setMap(mapData);
                    localActionZonesPolygons[i].actionZoneBuffer.setMap(mapData);
                }
            }

            if ((mapSideNavTabState.get() === "Action Zones" && cartPathActionZone.get()) || mapSideNavTabState.get() == "CPO") {
                if (localActionZonesPolygons[i].actionZoneInfo.Hole > 0) {
                    localActionZonesPolygons[i].setMap(mapData);
                    localActionZonesPolygons[i].actionZoneBuffer.setMap(mapData);
                }
            }

            if (mapSideNavTabState.get() === "Action Zones" && geofenceActionZone.get()) {
                if (localActionZonesPolygons[i].actionZoneInfo.IsGeofence) {
                    localActionZonesPolygons[i].setMap(mapData);
                    localActionZonesPolygons[i].actionZoneBuffer.setMap(mapData);
                }
            }
        }

        updateActionZoneBounds();
        loadingOnProcess.set(false);
    }

    const updateActionZoneBounds = () => {
        // Recalculate the bounds for all visible Action Zone Polygons
        var getCourseExtents = courseExtents.get();

        if (mapsData) {
            var boundsOfAZ = new mapsData.LatLngBounds();

            var bounds = {
                numberOfPositions: 0,
                bounds: boundsOfAZ
            }

            actionZonesPolygons.forEach((polygon) => {
                if (polygon.getMap()) {
                    if (polygon.actionZoneInfo.IsGeofence) {
                        if (getCourseExtents?.length) {
                            // extend the bounds to the course extents
                            boundsOfAZ.extend(getCourseExtents[0]);
                            boundsOfAZ.extend(getCourseExtents[1]);
                            bounds.numberOfPositions = getCourseExtents.length;
                        }
                    }
                    else {
                        var latLngs = polygon.getPath();

                        if (latLngs) {
                            latLngs.forEach(function (latLng) {
                                boundsOfAZ.extend(latLng);
                                bounds.numberOfPositions++;
                            });
                        }
                    }
                }
            });
        }
    }

    const hideDeleteVertexElement = () => {
        setVertexToDeleteIndex(-1);
        setVertexToDeletePath(null);
        createDeleteVertexElement()?.close();
    }

    const stopActionZonePanel = () => {
        cancelActionZoneEditHelper();
        openActionZoneWindow.set(false);
        hideDeleteVertexElement();
    }

    const closeActionZoneEdits = () => {
        stopActionZonePanel();
        addActionZonePolygon.set(false);
    }

    const closeActionZoneEditsOnMessage = () => {
        closeActionZoneEdits();
        messageActionZone.set((prevState) => !prevState);
        localStorage.setItem("messageActionZone", messageActionZone.get());
    }

    const closeActionZoneEditsOnControl = () => {
        closeActionZoneEdits();
        controlsActionZone.set((prevState) => !prevState);
        localStorage.setItem("controlsActionZone", controlsActionZone.get());
    }

    const closeActionZoneEditsOnCarPathOnly = () => {
        closeActionZoneEdits();
        cartPathActionZone.set((prevState) => !prevState);
        localStorage.setItem("cartPathActionZone", cartPathActionZone.get());
    }

    const closeActionZoneEditsOnGeofence = () => {
        closeActionZoneEdits();
        geofenceActionZone.set((prevState) => !prevState);
        localStorage.setItem("geofenceActionZone", geofenceActionZone.get());
    }

    const setNewActionZonePoly = () => {
        if (addActionZonePolygon.get()) {
            drawingManager?.setMap(mapData);
            drawingManager?.setDrawingMode(mapsData.drawing.OverlayType.POLYGON);
            // Setup variables such that we select the correct cursor
            isDrawingNewPolygon.set(true);
        } else {
            drawingManager?.setDrawingMode(null);
            // Setup variables such that we select the correct cursor
            isDrawingNewPolygon.set(false);
        }

        selectEditAzPolygonCursor();
    }

    const handleCancelEditActionZone = () => {
        stopActionZonePanel();
        setAlertModalIsOpen(false);
    }

    const createDeleteVertexElement = () => {
        let deleteVertexButton = null;

        if (mapsData) {
            deleteVertexButton = class DeleteMenu extends mapsData.OverlayView {
                div_;
                divListener_;

                constructor() {
                    super();
                    this.div_ = document.createElement("button");
                    this.div_.style.cssText = `
                  background-color: #fff; 
                  width:30px; height:25px; 
                  border-radius:4px; 
                  position: fixed; 
                  border:none; 
                  font-size:14px; `;
                    this.div_.innerHTML = "x";
                    this.div_.className = "map-cross-icon";
                    this.div_.title = "Delete";

                    const menu = this;

                    this.div_.addEventListener("click", () => {
                        menu.removeVertex();
                    });
                }

                onAdd() {
                    const deleteVertexButton = this;
                    const map = this.getMap();

                    this.getPanes().floatPane.appendChild(this.div_);

                    this.divListener_ = (e) => {
                        if (e.target !== deleteVertexButton.div_) {
                            deleteVertexButton.close();
                        }
                    };

                    map.getDiv().addEventListener("mousedown", this.divListener_, true);
                }

                onRemove() {
                    if (this.divListener_) {
                        this.getMap()?.getDiv().removeEventListener(
                            "mousedown",
                            this.divListener_,
                            true
                        );
                    }

                    this.div_.parentNode.removeChild(this.div_);
                    this.set("position", null);
                    this.set("path", null);
                    this.set("vertex", null);
                }

                close() {
                    this.setMap(null);
                }

                draw() {
                    const position = this.get("position");
                    const projection = this.getProjection();

                    if (!position || !projection) {
                        return;
                    }

                    const point = projection.fromLatLngToDivPixel(position);
                    this.div_.style.top = point.y + "px";
                    this.div_.style.left = point.x + "px";
                }

                open(map, path, vertex, polygon) {
                    this.set("position", path.getAt(vertex));
                    this.set("path", path);
                    this.set("vertex", vertex);
                    this.set("polygon", polygon);
                    this.setMap(map);
                    this.draw();
                }

                removeVertex() {
                    const path = this.get("path");
                    const vertex = this.get("vertex");
                    const polygon = this.get("polygon");

                    let foundPoly = actionZonesPolygons.find((item) => item.actionZoneInfo.Id === polygon.actionZoneInfo.Id);

                    if (!path || vertex === undefined) {
                        this.close();
                        return;
                    }

                    let arr1 = [];
                    const vertices1 = polygon.getPaths().getArray()[0];

                    vertices1.forEach((vertex) => {
                        arr1.push({
                            Id: 0,
                            Longitude: vertex.lng(),
                            Latitude: vertex.lat(),
                        });
                    });

                    let duplicateIndex = [];

                    for (let i = 0; i < arr1.length; i++) {
                        if (arr1[vertex].Latitude === arr1[i].Latitude &&
                            arr1[vertex].Longitude === arr1[i].Longitude) {
                            duplicateIndex.push(i);
                        }
                    }

                    duplicateIndex.sort((a, b) => b - a);
                    duplicateIndex.forEach((item) => path.removeAt(item));

                    setPolygonActionZoneBufferPath(foundPoly || polygon);

                    this.close();
                }
            };
        }

        return deleteVertexButton ? new deleteVertexButton() : null;
    }

    return (
        <>
            <AlertModal
                handleOnSubmit={alertModalHandleOnSubmit}
                handleOnClose={alertModalHandleOnClose}
                title={alertModalTitle}
                content={alertModalContent}
                isOpen={alertModalIsOpen}
                setOpenAlert={setAlertModalIsOpen}
                validation={alertModalValidation}
            />
        </>
    );
}